module.exports = __webpack_public_path__ + "img/no-image.55538b4d.png";